import Component from '../../shared/component';
import StringHelper from '../../helpers/string-helper';

const BADGE_COUNT_REFRESH_INTERVAL = 20000;

// @class BadgeCounter
// @param {badges} opts.badges List of dynamic badges
export default class BadgeCounter extends Component {
  constructor(element, opts) {
    super(...arguments);

    this.$element = $(element);

    this.opts = opts;
    this.action = this.$element.attr('data-action');

    this.bindTimeout();
  }

  bindTimeout() {
    this.timeout = setTimeout(() => {
      if (this.timeout) {
        this.fetchData();
      }
    }, BADGE_COUNT_REFRESH_INTERVAL);
  }

  unbindEvents() {
    clearTimeout(this.timeout);
    this.timeout = null;
  }

  fetchData() {
    $.getJSON(this.action).done((data) => this.handleAJAXSuccess(data));
  }

  handleAJAXSuccess(data) {
    this.bindTimeout();
    this.displayBadges(data);
  }

  displayBadges(data) {
    Object.keys(data).forEach((key) => {
      const $badge = $(this.opts.badges[StringHelper.toCamelCase(key)]);
      const value = data[key];

      if (value > 0) {
        $badge.html(value);
        $badge.removeClass('hidden');
      } else {
        $badge.addClass('hidden');
      }
    });
  }
}
